module.exports = __webpack_public_path__ + "img/icon-ranking-5@2x.f45518d1.png";